/** localStorage key holding the user's workspace selection: an organization id or `PERSONAL_WORKSPACE_SELECTION`. */
export const ACTIVE_ORG_ID_STORAGE_KEY = "muggle.activeOrganizationId";

/** Selection value meaning the user chose their personal workspace over every organization. */
export const PERSONAL_WORKSPACE_SELECTION = "personal";

/** Route of the active organization's overview page. */
export const ORGANIZATION_OVERVIEW_PATH = "/muggleTestV0/dashboard/organization";
